import React from 'react'
import { Link } from 'react-router-dom'
import Blog_1 from '../../../assets/images/blog/blog-two-1.jpg'
import Blog_2 from '../../../assets/images/blog/blog-two-auther-1.png'
import Blog_3 from '../../../assets/images/blog/blog-two-2.jpg'
import Blog_4 from '../../../assets/images/blog/blog-two-auther-2.png'

const Blog = () => {
    return (
        <>
            <div className="blog-section-two">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 m-auto">
                            <div className="heading-box light text-center">
                                <span
                                    className="sub-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Blog
                                </span>
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Read &amp; gather knowledge from our latest news
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-x-15 gutter-y-30">
                        <div className="col-lg-6">
                            <div
                                className="blog-box-two animate fadeInUp wow"
                                data-wow-duration="1500ms"
                            >
                                <div className="blog-image-two">
                                    <img src={Blog_1} alt="blog-image" />
                                    <ul className="blog-tag-two">
                                        <li>
                                            <Link to="/BlogDetails">Business</Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails">Consulting</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="blog-meta-date-two">
                                    <Link to="/BlogDetails">18 November 2024 </Link>
                                </div>
                                <h4>
                                    <Link to="/BlogDetails">
                                        Understanding behavioral biases and making to the rational way
                                    </Link>
                                </h4>
                                <p>
                                    Results driven marketing campaigns are deployed to achieve client’s
                                    objectives. A strong return on investment is the main goal, achieved
                                    by individual marketing.
                                </p>
                                <div className="blog-meta-two">
                                    <div className="blog-author-two">
                                        <img
                                            src={Blog_2}
                                            alt="author-image"
                                        />
                                        <p>by Kalvin</p>
                                    </div>
                                    <Link to="/BlogDetails" className="btn btn-dark btn-theme">
                                        Read More <span>+</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="blog-box-two animate fadeInUp wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="blog-image-two">
                                    <img src={Blog_3} alt="blog-image" />
                                    <ul className="blog-tag-two">
                                        <li>
                                            <Link to="/BlogDetails">Business</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="blog-meta-date-two">
                                    <Link to="/BlogDetails">18 November 2024 </Link>
                                </div>
                                <h4>
                                    <Link to="/BlogDetails">
                                        Understanding behavioral biases and making to the rational way
                                    </Link>
                                </h4>
                                <p>
                                    Consulting services give access to more experienced levels of
                                    expertise than would be feasible to retain in house. Consultants
                                    provide expertise to clients.
                                </p>
                                <div className="blog-meta-two">
                                    <div className="blog-author-two">
                                        <img
                                            src={Blog_4}
                                            alt="author-image"
                                        />
                                        <p>by John Mathew</p>
                                    </div>
                                    <Link to="/BlogDetails" className="btn btn-dark btn-theme">
                                        Read More <span>+</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Blog
